import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
}), 'ExpandLessTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExpandLessTwoTone.js
// module id = 3442
// module chunks = 2